<template>
    <section class="post-list">
        <div class="container">
            <div class="row">
                <template v-for="(post, index) in posts">
                    <transition :key="post.ID" name="fade">
                        <a class="post-list__item" :key="post.ID" v-if="index < postsNumer" :href="post.url">
                            <span class="post-list__item__image" v-bind:style="{ 'background-image': 'url(' + post.thumbnail + ')' }"></span>
                            <p class="post-list__item__title" v-html="post.post_title"></p>
                            <span class="post-list__item__readmore">Read more</span>
                        </a>
                    </transition>
                </template>
            </div>
            <div class="row">
                <div class="post-list__loadmore" @click="postsNumer += postsPerPage" v-if="postsNumer < posts.length">Load more</div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'Blog',
    data() {
        return {
            postsPerPage: 8,
            postsNumer: 8,
            posts: []
        }
    },
    create: function() {
    },
    methods: {
    },
    mounted() {
        this.axios.get('/wp-json/blog/v1/post')
            .then(response => {
                this.posts = response.data;
            });
	},
}
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>
